import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import Navbar from "../../layout/Navbar"
import Footer from "../../layout/Footer"
import SEO, { getSEOData } from "../../components/SEO"
import HeroPartner from "./HeroPartner"
import BenefitsPartner from "./BenefitsPartner"
import HowItWorks from "./HowItWorks"
import EarningsPartner from "./EarningsPartner"
import DocumentsPartner from "./DocumentsPartner"
import TestimonialsPartner from "./TestimonialsPartner"
import FaqPartner from "./FaqPartner"
import DownloadPartner from "./DownloadPartner"
import "./partnerNew.scss"

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How do I register as a cab driver or fleet partner with Pulpit?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Fill out the registration form with your details, fleet size, city, and vehicle types. Our team verifies your documents and activates you on the platform within 24-48 hours.",
      },
    },
    {
      "@type": "Question",
      name: "What documents are required for partner registration?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Drivers need a valid commercial driving license, Aadhaar card, PAN card, vehicle RC, commercial insurance, PUC certificate, fitness certificate, and All India Tourist Permit. Fleet owners additionally need GST registration, company registration, and authorization letters.",
      },
    },
    {
      "@type": "Question",
      name: "When and how do I receive my payouts?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Payouts follow a weekly cycle. Monday to Sunday trips are settled every Tuesday via NEFT/IMPS to your registered bank account. Minimum payout threshold is Rs 500.",
      },
    },
    {
      "@type": "Question",
      name: "Which cities and routes does Pulpit operate in?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Pulpit operates across 450+ cities PAN-India with a focus on outstation routes covering Delhi NCR, Maharashtra, Gujarat, Karnataka, Rajasthan, UP, and Tamil Nadu.",
      },
    },
  ],
}

const PartnerNew = () => {
  const seo = getSEOData("partner")
  const [showSticky, setShowSticky] = useState(false)

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > 600)
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  const scrollToForm = () => {
    const hero = document.querySelector(".hero-partner")
    if (hero) hero.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <div className="partner-new">
      <SEO
        title={seo.title.replace(" | Pulpit", "").replace("Pulpit - ", "")}
        description={seo.description}
        keywords={seo.keywords}
      />
      <Helmet defer={false}>
        <script type="application/ld+json">{JSON.stringify(FAQ_SCHEMA)}</script>
      </Helmet>
      <Navbar page="partner" />
      <HeroPartner />
      <BenefitsPartner />
      <HowItWorks />
      <EarningsPartner />
      <DocumentsPartner />
      <TestimonialsPartner />
      <FaqPartner />
      <DownloadPartner />
      <Footer />
      {showSticky && (
        <button className="partner-new__sticky-cta" onClick={scrollToForm}>
          Register Now
        </button>
      )}
    </div>
  )
}

export default PartnerNew
